import {
  mapToSiteAddress,
  type SiteAddressOut,
} from "@/shared/endpoints/inout/SiteAddressOut.ts";
import {
  type ScheduleTemplateOut,
  templateMapper,
} from "@/pages/human-resources/time-management/endpoints/schedules/templates/inout/ScheduleTemplateOut.ts";
import {
  type DailyTagOut,
  mapToDailyTag,
} from "@/pages/human-resources/time-management/endpoints/tags/inout/DailyTagOut.ts";
import type { IndicatorsGroupOut } from "@/pages/human-resources/time-management/endpoints/indicators/inout/IndicatorsGroupOut.ts";
import type { Site } from "@/shared/model/user/UserDomains.ts";
import type { DomainScheduleReferenceData } from "@/pages/human-resources/time-management/business/reference/DomainScheduleReferenceData.ts";
import { SiteScheduleReferenceData } from "@/pages/human-resources/time-management/business/reference/SiteScheduleReferenceData.ts";
import parsePreferences from "@/pages/human-resources/time-management/business/preferences/PreferencesParser.ts";
import { mapIndicatorsGroups } from "@/pages/human-resources/time-management/services/IndicatorsMapper.ts";

export interface SiteScheduleReferenceDataOut {
  siteId: string;
  addressOut: SiteAddressOut;
  templatesOut: ScheduleTemplateOut[];
  tagsOut: DailyTagOut[];
  indicatorsOut: IndicatorsGroupOut[];
}

export function mapToSiteScheduleReferenceData(
  site: Site,
  domainData: DomainScheduleReferenceData,
  out: SiteScheduleReferenceDataOut,
): SiteScheduleReferenceData {
  return new SiteScheduleReferenceData(
    out.siteId,
    parsePreferences(site),
    mapToSiteAddress(out.addressOut),
    out.templatesOut.map(
      templateMapper(
        domainData.hourlyTagsResolver,
        domainData.domainId,
        out.siteId,
      ),
    ),
    out.tagsOut.map(mapToDailyTag),
    mapIndicatorsGroups(out.indicatorsOut),
  );
}
